import { render } from "./TopPage.vue?vue&type=template&id=31b9d1fb&scoped=true&ts=true"
import script from "./TopPage.vue?vue&type=script&lang=ts"
export * from "./TopPage.vue?vue&type=script&lang=ts"

import "./TopPage.vue?vue&type=style&index=0&id=31b9d1fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b9d1fb"]])

export default __exports__